module.exports = __webpack_public_path__ + "static/media/banner.04053e0d.png";